import { call, put, select, takeLeading, all } from 'redux-saga/effects'
import { get } from 'lodash'
import moment from 'moment'

import {
  menusSucceeded,
  menusItemsSucceeded,
  menusItemsNotNeeded,
  currentMenuItemsNotNeeded,
  MENUS_REQUESTED,
  MENUS_ITEMS_REQUESTED,
  CURRENT_MENU_SELECTED,
  MENUS_AND_ITEMS_REQUESTED,
  currentMenuItemsSucceeded,
  updateLastMenuRequestTimestamp,
} from '../actions/menus'
import { getSelectedMenusIds } from '../selectors/config'
import { getCurrentMenuId } from '../selectors/appState'
import { getCurrentMenu, getMenusNeedReload } from '../selectors/menus'
import { getItemsNeedReload } from '../selectors/items'

import Stadium from '@ordernext/networking-stadium/stadium'
import Remote from '../remote'

export function* getMenus(params) {
  const ignoreThrottle = params?.payload?.ignoreThrottle
  const allowRequest = yield select(getMenusNeedReload)

  if (ignoreThrottle || allowRequest) {
    const organizationName = yield select((state) => state?.config?.organizationName ?? '')
    const menu = yield select(getCurrentMenu)
    const standUuid = menu?.standUuid
    const payload = { organizationName, standUuid }

    try {
      const result = yield call.call(null, Remote.getRevenueCenters, payload)
      yield put(menusSucceeded(result))
      yield put(updateLastMenuRequestTimestamp(moment().toString()))

    } catch (error) {
      console.log(error)
    }
  }
}

export function* getCurrentMenuItems() {
  const menuUuid = yield select(getCurrentMenuId)
  const orgName = yield select((state) => get(state, 'config.organizationName', ''))
  const currentItems = yield select((state) => select((state) => state?.items?.byMenuId?.[menuUuid]))

  if (currentItems === null) {
    try {
      const result = yield call(Stadium.getPosMenu, menuUuid, orgName)
      yield put(currentMenuItemsSucceeded([result]))
    } catch (error) {
      console.log(error)
    }
  } else {
    yield put(currentMenuItemsNotNeeded())
  }
}

export function* getMenusItems(params) {
  const ignoreThrottle = params?.payload?.ignoreThrottle
  const allowRequest = yield select(getItemsNeedReload)

  if (ignoreThrottle || allowRequest) {
    try {
      const orgName = yield select((state) => get(state, 'config.organizationName', ''))
      const menuUuids = yield select(getSelectedMenusIds)
      const result = yield all(menuUuids.map(menuUuid => call(Stadium.getPosMenu, menuUuid, orgName)))

      yield put(menusItemsSucceeded(result))
      yield put(updateLastMenuRequestTimestamp(moment().toString()))
    } catch (error) {
      console.log(error)
    }
  } else {
    yield put(menusItemsNotNeeded())
  }
}

export function* getMenusAndItems(action) {
  yield getMenus(action)
  yield getMenusItems(action)
}

export function* watchGetMenus() {
  yield takeLeading(MENUS_REQUESTED, getMenus)
}

export function* watchGetCurrentMenuItems() {
  yield takeLeading(CURRENT_MENU_SELECTED, getCurrentMenuItems)
}

export function* watchGetMenusItems() {
  yield takeLeading(MENUS_ITEMS_REQUESTED, getMenusItems)
}

export function* watchGetMenusAndItems() {
  yield takeLeading(MENUS_AND_ITEMS_REQUESTED, getMenusAndItems)
}
